<script>
import {useCartStore} from "@js/store/CartStore.js";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import CallbackErrorMessage from "@js/components/Statuses/CallbackErrorMessage.vue";
import {IMaskDirective} from 'vue-imask';
import PrivacyPolicyAgreementLink from "@js/components/Sections/Links/PrivacyPolicyAgreementLink.vue";

export default {
    name: "CartForm",
    components: {PrivacyPolicyAgreementLink, CallbackErrorMessage, NumberFormatComponent},
    directives: {
        imask: IMaskDirective
    },
    data() {
        return {
            phoneMask: {
                mask: '+7 (000) 000-00-00',
            },
        }
    },
    methods: {
        updatePhone(newPhone) {
            this.cartStore.form.phone = newPhone;
        },
    },
    setup() {
        const cartStore = useCartStore()

        return {cartStore}
    },
    computed: {
        allProductsPriceSum: function () {
            return this.cartStore.allProductsPriceSum()
        }
    }
}
</script>

<template>
    <div class="flex flex-col bg-grayBg rounded-2xl p-4 gap-5">
        <div>
            <h2 class="text-lg font-medium mb-3">
                Стоимость заказа
            </h2>
            <div class="flex items-end justify-between w-full text-sm mb-2">
                <div class="font-medium">
                    Стоимость товаров
                </div>
                <div class="font-bold">
                    <NumberFormatComponent :number="allProductsPriceSum" append_text=" ₽"/>
                </div>
            </div>
            <div class="flex items-end justify-between w-full text-sm">
                <div class="font-medium">
                    Стоимость доставки
                </div>
                <div class="font-bold">
                    <NumberFormatComponent :number="cartStore.deliveryCost" append_text=" ₽"/>
                </div>
            </div>
            <hr class="my-3 border-gray-300"/>
            <div class="flex items-end justify-between w-full">
                <div class="font-medium">
                    Итого к оплате
                </div>
                <div class="font-bold">
                    <NumberFormatComponent :number="allProductsPriceSum + cartStore.deliveryCost" append_text=" ₽"/>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-3">
            <h2 class="text-lg font-medium">
                Оформление заказа
            </h2>
            <div>
                <input type="text" placeholder="Ф.И.О.*" v-model="cartStore.form.full_name"
                       autocomplete="off"
                       class="block w-full px-0 py-2 text-gray-700 placeholder-gray-500 bg-transparent border-0 border-b-2 border-baseColor focus:outline-none focus:ring-0 focus:border-baseColor transition"
                       :class="[cartStore.form_errors && cartStore.form_errors['full_name'] ? 'border-red-600' : '']"/>
                <CallbackErrorMessage :error="cartStore.form_errors"
                                      :error-msg="'full_name'"/>
            </div>
            <div>
                <input type="tel"
                       @keyup="updatePhone($event.target.value)"
                       :value="cartStore.form.phone"
                       v-imask="phoneMask"
                       placeholder="+7 (___) ___-__-__*" autocomplete="off"
                       class="block w-full px-0 py-2 text-gray-700 placeholder-gray-500 bg-transparent border-0 border-b-2 border-baseColor focus:outline-none focus:ring-0 focus:border-baseColor transition"
                       :class="[cartStore.form_errors && cartStore.form_errors['phone'] ? 'border-red-600' : '']"/>
                <CallbackErrorMessage :error="cartStore.form_errors"
                                      :error-msg="'phone'"/>
            </div>
            <div>
                <input type="email" placeholder="Email" v-model="cartStore.form.email"
                       autocomplete="off"
                       class="block w-full px-0 py-2 text-gray-700 placeholder-gray-500 bg-transparent border-0 border-b-2 border-baseColor focus:outline-none focus:ring-0 focus:border-baseColor transition"
                       :class="[cartStore.form_errors && cartStore.form_errors['email'] ? 'border-red-600' : '']"/>
                <CallbackErrorMessage :error="cartStore.form_errors"
                                      :error-msg="'email'"/>
            </div>
            <div class="mt-2">
                <textarea rows="4" v-model="cartStore.form.comment"
                          class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border-2 border-gray-300 focus:ring-0 focus:border-baseColor"
                          placeholder="Комментарий к заказу..."></textarea>
            </div>
            <div class="mt-5">
                <PrivacyPolicyAgreementLink/>
            </div>
            <div>
                <button type="button" @click.prevent="cartStore.sendForm"
                        class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-baseColor md:hover:bg-baseColor/80 text-black focus:outline-none focus:ring-0 font-bold rounded-xl text-sm px-5 py-4 transition">
                    Оформить заказ
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
